module.exports = __webpack_public_path__ + "img/theme9.e363bb3c.png";